export default function ProblemStatement() {
  const problems = [
    {
      icon: 'ri-grid-line', iconColor: 'text-red-500', bgColor: 'bg-red-500/10',
      title: 'Scattered across 10 tabs',
      description: 'LinkedIn, email, spreadsheets, sticky notes. No single source of truth for where you applied, who you spoke to, or what\'s next.'
    },
    {
      icon: 'ri-file-list-3-line', iconColor: 'text-orange-500', bgColor: 'bg-orange-500/10',
      title: 'Filling the same form 50 times',
      description: 'Every ATS asks for the same information. Name, address, resume, LinkedIn URL — typed manually, every single time.'
    },
    {
      icon: 'ri-file-text-line', iconColor: 'text-yellow-500', bgColor: 'bg-yellow-500/10',
      title: 'Sending the same resume everywhere',
      description: 'One generic resume for every role. No tailoring. The ATS rejects it before a human ever reads it.'
    }
  ];

  const scrollToFeatures = () => {
    const element = document.getElementById('features');
    if (!element) return;
    const offset = 80;
    const offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };

  return (
    <section id="problem" className="py-24 bg-gray-50 dark:bg-[#0A0E1A]">
      <div className="max-w-[1280px] mx-auto px-6">
        <h2 className="text-center text-[48px] md:text-[56px] font-extrabold leading-[1.1] tracking-tight mb-4">
          <div className="text-gray-900 dark:text-white">Job searching is broken.</div>
          <div className="text-gray-400 dark:text-[#94A3B8]">You're managing it in spreadsheets.</div>
        </h2>
        <div className="grid md:grid-cols-3 gap-8 mt-16 mb-12">
          {problems.map((problem, index) => (
            <div key={index} className="bg-white dark:bg-[#141828] border border-gray-200 dark:border-[#2D3148] rounded-xl p-8 hover:border-[#6366F1]/30 transition-all duration-300">
              <div className={`w-14 h-14 ${problem.bgColor} rounded-lg flex items-center justify-center mb-6`}>
                <i className={`${problem.icon} text-2xl ${problem.iconColor}`}></i>
              </div>
              <h3 className="text-gray-900 dark:text-[#F8FAFC] text-xl font-bold mb-3">{problem.title}</h3>
              <p className="text-gray-500 dark:text-[#94A3B8] text-base leading-[1.6]">{problem.description}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-16">
          <button onClick={scrollToFeatures} className="inline-flex items-center gap-3 text-[#6366F1] text-2xl font-bold hover:text-[#818CF8] transition-colors duration-200 cursor-pointer group">
            JobOS solves all three. At once.
            <i className="ri-arrow-down-line text-2xl group-hover:translate-y-1 transition-transform duration-200"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
